<template>
    <div
        class="form-group"
        :class="[
            {
                'form-row': horizontal,

            },
        ]"
        v-if="typeSelect === 'SearchSelect'"
    >
        <label
            v-if="label"
            :class="[
                { 'col-form-label': horizontal },
                horizontal ? class_label : '',
                size == 'sm' ? 'col-form-label-sm' : '',
            ]"
        >
            {{ label }}
        </label>
        <div
            :class="[
                horizontal ? class_input : '',
                size == 'sm' ? 'input-group-sm' : '',
                'search-select-wrapper',
            ]"
        >
            <model-select
                :options="optionsComponent"
                v-model="valueComponent"
                :name="name"
                :placeholder="placeholder"
                class="form-control"
                :class="{
                    'is-valid': isValid == true && disabled == false,
                    'is-invalid': isValid == false && disabled == false,
                    disabled: disabled == true,
                }"
                @change="onChange($event)"
            >
            </model-select>
            <div
                v-if="resetOption && valueComponent"
                class="btn-reset"
                @click="reset()"
            >
                <span class="btn-reset__icon"
                    ><CIcon :content="$options.icons.cilX"
                /></span>
            </div>
            <div v-if="isValid == false" class="invalid-feedback">
                {{ invalidFeedback }}
            </div>
        </div>
    </div>
    <CSelect
        :isValid="isValid"
        :value.sync="valueComponent"
        :options="optionsComponent"
        @change="onChange($event)"
        :label="label"
        :placeholder="placeholder"
        :invalidFeedback="invalidFeedback"
        :horizontal="horizontal"
        :disabled="disabled"
        :size="size"
        v-else-if="typeSelect === 'CSelect'"
    />

    <SelectTags
        v-else-if="typeSelect === 'SelectTags' && optionsLoaded"
        :placeholder="placeholder"
        :value.sync="valueComponent"
        :options="optionsComponent"
        :horizontal="horizontal"
        :disabled="disabled"
        :size="size"
        :label="label"
        :onlyValue="true"
        :max="max"
        optionsLabel="label"
    />
</template>

<script>
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import axios from "axios";
import { cilX } from "@coreui/icons";
import { getValueByPath } from "../../utils";
import SelectTags from "£lement/SelectTags";
export default {
    name: "SelectAsync",
    components: {
        ModelSelect,
        SelectTags,
    },
    icons: {
        cilX,
    },
    data() {
        return {
            optionsComponent: [],
            optionsLoaded: false,
            valueComponent: this.value,
            class_label: "col-sm-3",
            class_input: "col-sm-9",
        };
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: "",
        },
        className: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "Select item",
        },
        isValid: {
            type: Boolean,
            default: null,
        },
        options: {
            default: null,
            type: Array,
        },
        value: {
            default: null,
        },
        horizontal: {
            default: false,
        },
        size: {
            default: undefined,
        },
        max: {
            default: null,
        },
        invalidFeedback: {
            default: undefined,
        },
        disabled: {
            default: false,
        },

        /* Custom props */
        endpoint: {
            type: String,
        } /* modelName */,
        fetchConfig: {
            type: Object,
        },
        optionsValue: {
            type: String | Function,
        } /* valueAttribute */,
        optionsLabel: {
            type: String | Function,
        } /* valueName */,

        matchResponseItems: {
            type: String | null,
            default: null,
        },

        loadOptions: {
            type: Function,
        },
        formatOptions: {
            type: Function,
        },

        typeSelect: {
            type: String,
            default: "SearchSelect",
        },

        resetOption: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        valueComponent(newValue) {
            this.$emit("update:value", newValue);
            this.$emit("change", newValue);
            let option = this.optionsComponent.find((item) => {
                return item.value == newValue;
            });
            this.$emit("changeOption", option);
        },
        value(newValue) {
            this.valueComponent = newValue;
        },

        options(newValue) {
            if (this.options.length > 0) {
                this.optionsComponent = newValue;
            }
            this.serializeData(this.optionsComponent);
        },

        /* optionsComponent(newValue) {
            this.$emit("update:options", newValue);
        }, */
        async endpoint(newValue) {
            if (this.options.length > 0) {
                this.optionsComponent = this.options;
                this.serializeData(this.optionsComponent);
            } else {
                this.reload();
            }
        },
    },
    methods: {
        serializeData(data) {
            if (this.formatOptions) {
                this.optionsComponent = this.formatOptions(data);
                return true;
            }
            let items = [];
            if (
                this.matchResponseItems &&
                getValueByPath(data, this.matchResponseItems)
            ) {
                items = getValueByPath(data, this.matchResponseItems);
            } else if (data.items) {
                items = data.items;
            } else if (data._items) {
                items = data._items;
            } else {
                items = data;
            }
            if (this.optionsValue && this.optionsLabel) {
                this.optionsComponent = items.map((item) => {
                    let value;
                    if (this.optionsValue instanceof Function) {
                        value = this.optionsValue(item);
                    } else {
                        value = item[this.optionsValue];
                    }

                    let text;
                    if (this.optionsLabel instanceof Function) {
                        text = this.optionsLabel(item);
                    } else {
                        text = item[this.optionsLabel];
                    }
                    return {
                        value,
                        text,
                        label: text,
                    };
                });
            } else {
                this.optionsComponent = items.map((item) => {
                    return {
                        text: item,
                        value: item,
                        label: item,
                    };
                });
            }
        },
        loadOptionsComponent: async function () {
            try {
                const { data } = await axios.get(
                    this.endpoint,
                    this.fetchConfig
                );
                return data;
            } catch (error) {
                console.log(error);
            }
        },
        setHorizontalClass: function () {
            if (this.horizontal.label) {
                this.class_label = this.horizontal.label;
            }
            if (this.horizontal.input) {
                this.class_input = this.horizontal.input;
            }
        },
        onChange(event) {},
        reset() {
            this.valueComponent = null;
        },
        setComponentValue(value) {
            this.$set(this, "valueComponent", value);
        },
        getComponentValue() {
            return this.valueComponent;
        },

        async reload() {
            this.optionsLoaded = false;
            this.optionsComponent = await this.loadOptionsComponent();
            this.serializeData(this.optionsComponent);
            this.optionsLoaded = true;
        },
    },
    async mounted() {
        if (this.options) {
            this.optionsComponent = this.options;
        } else {
            this.optionsComponent = await this.loadOptionsComponent();
        }
        this.serializeData(this.optionsComponent);
        this.setHorizontalClass();
        this.optionsLoaded = true;
    },
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap.scss";
.ui.dropdown {
    & .icon {
        background: transparent !important;
    }
}
.ui.selection.dropdown {
    & .text.default {
        color: #6c757d;
    }
}
.ui.selection.dropdown.is-invalid {
    @extend .is-invalid;
    & .icon {
        opacity: 0;
    }
}
.ui.selection.dropdown.is-valid {
    @extend .is-valid;
    & .icon {
        opacity: 0;
    }
}

.input-group-sm {
    & .ui.search.dropdown {
        & .text {
            top: -0.2em;
        }
    }
}

.search-select-wrapper {
    position: relative;
    width: 100%;
    & .btn-reset {
        position: absolute;
        right: 1%;
        top: 0;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(0.75em + 0.475rem);
        & .btn-reset__icon {
            background-color: white;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
